import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import User from 'main/stores/users/User';

class TimeOffRequestAssignment extends DomainObject {
  approvalStage;

  _relations = {
    assigneeUser: User,
    delegatedByUser: User,
    approvalStage: oneOf(['first', 'second'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      approvalStage: observable
    });

    this.merge(other);
  }
}

export default TimeOffRequestAssignment;
